import { useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { SIGN_IN_STEP_PARAM_KEY, STEPS } from '@/modules/user/components/SignIn/signIn.types';

const useInitialStepFromUrl = (setStep: (step: STEPS) => void): void => {
  const location = useLocation();
  const history = useHistory();

  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    const stepParam = params.get(SIGN_IN_STEP_PARAM_KEY);

    if (stepParam && Object.values(STEPS).includes(stepParam as STEPS)) {
      setStep(stepParam as STEPS);
    }

    if (stepParam) {
      params.delete(SIGN_IN_STEP_PARAM_KEY);
      const newSearch = params.toString();
      const searchPrefix = newSearch ? '?' : '';
      const newUrl = location.pathname + searchPrefix + newSearch;
      history.replace(newUrl);
    }
  }, [location.search, location.pathname, history, setStep]);
};

export default useInitialStepFromUrl;
